import { Injectable } from '@angular/core';
import { ScheduleJob } from './schedulejob';
import { Observable, throwError, of, Subject, BehaviorSubject, Subscription } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component';
import { AuthService } from '../auth.service';



// A day's job list tagged with the MM-DD-YYYY it was fetched for, so stale responses can be dropped.
export interface DayJobsMsg {
  date: string;
  jobs: ScheduleJob[];
  pages?: number;
}

@Injectable({
  providedIn: 'root'
})

export class ScheduleService {

  checkDayStatus(empid: any, timezone: any):Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/checkDayStatus/' + empid, {timezone: timezone}, {observe: 'body'});
  }


  OFFICE = 2;
  NORMAL = 1;

  getTodaysById(id: any, version: number = this.NORMAL) {

    const today = this.getTodayFormatted();
    if(version != this.OFFICE)
    {
      this.getTodaysJobsID(id).subscribe(
        res => {
          if(res.Rows > 0){
            this.loadingDate.next(false);
            this.authenticatedAndFiltered = true;
            this.subject.next({date: today, jobs: res.Jobs});
            this.loadAllActivated.next(false);
          }
        }
      )
    }else {
      this.getTodaysJobsSVID(id).subscribe(
        res => {
          if(res.Rows > 0){
            this.loadingDate.next(false);
            this.authenticatedAndFiltered = true;
            this.subject.next({date: today, jobs: res.Jobs});
            this.loadAllActivated.next(false);
          }
        }
      )
    }

  }

  private baseURL = environment.baseUrl;
  private subject = new BehaviorSubject<DayJobsMsg>({date: '', jobs: []});
  // In-flight requests for the last picked date; cancelled when a new date is picked
  private pageSub: Subscription;
  private daySub: Subscription;
  private loadingDate = new BehaviorSubject<boolean>(true);
  private loadAllActivated = new BehaviorSubject<boolean>(false);
  // True while the full day's job list is being fetched
  private loadingAll = new BehaviorSubject<boolean>(false);
  private initialSubject = new BehaviorSubject<ScheduleJob[]>([]);
  private userProfile = new BehaviorSubject<any>([]);

  //getAllJobs
  private allJobsSubject = new BehaviorSubject<DayJobsMsg>({date: '', jobs: []});
  allJob$ = this.allJobsSubject.asObservable();

  private dayStarted = new BehaviorSubject<boolean>(false);
  private firstJob = new BehaviorSubject<boolean>(false);
  private isPaused = new BehaviorSubject<boolean>(false);
  private isClockedIn = new BehaviorSubject<boolean>(false);

  private pages = new BehaviorSubject<number>(0);

  gridObject$: Observable<DayJobsMsg> = this.subject.asObservable();
  officeGridObject$: Observable<DayJobsMsg> = this.subject.asObservable();
  loadingD$: Observable<boolean> = this.loadingDate.asObservable();
  initial$: Observable<ScheduleJob[]> = this.initialSubject.asObservable();
  loadAllActivated$: Observable<boolean> = this.loadAllActivated.asObservable();
  loadingAll$: Observable<boolean> = this.loadingAll.asObservable();
  page$:Observable<number> = this.pages.asObservable();
  profile$:Observable<any> = this.userProfile.asObservable();


  isLoading = true;
  authenticatedAndFiltered = false; //to be used for non tmanagers

  daystarted = false;
  id;

  constructor(private http: HttpClient, private messager: MessagerComponent, private auth: AuthService) {}

  init(version: number = this.NORMAL): void {

    let profile;
    this.profile$.subscribe(
      res => {
        profile = res;
      }
    )
    this.id = profile['https://rhv2.com.metadata'].id

    //see if there's a 'day' entry in the daytable
    let today = new Date();
    let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.auth.userProfile$.subscribe(
      (profile) => {
        
        this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/getDayStatuses/' + this.auth.getEmployeeId(), {timezone: timezone}, {observe: 'body'}).subscribe(
          res =>{
            this.dayStarted.next(res.data.daystarted);
            this.isPaused.next(res.data.daypaused);
            this.firstJob.next(res.data.donefirstjob);
          }
        )

        /*
        this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/isDayStarted/' + this.auth.getEmployeeId(), {timezone: timezone}, {observe: 'body'}).subscribe(
          res => {
              this.dayStarted.next(res.data);
            },
          err => {
            this.messager.openSnackBar('There was an error loading timecard: ' + err, '', 'errorAlert');
          }
        );

        this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/doneFirstJob/' + this.auth.getEmployeeId(), {timezone: timezone}, {observe: 'body'}).subscribe(
          res => {
              this.firstJob.next(res.data);
            },
          err => {
            this.messager.openSnackBar('There was an error loading timecard: ' + err, '', 'errorAlert');
          }
        );

        this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/isPaused/' + this.auth.getEmployeeId(), {timezone: timezone}, {observe: 'body'}).subscribe(
          res => {
              this.isPaused.next(res.data);
            },
          err => {
            this.messager.openSnackBar('There was an error loading timecard: ' + err, '', 'errorAlert');
          }
        );
        */

        this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/stillClockedIn/' + this.auth.getEmployeeId(), {timezone: timezone}, {observe: 'body'}).subscribe(
          res => {
              this.isClockedIn.next(res.data);
            },
          err => {
            this.messager.openSnackBar('There was an error loading timecard: ' + err, '', 'errorAlert');
          }
        );
      }
    )

    this.getTodaysById(this.id, version);

    //load ALL OF todays jobs
    const todayStr = this.getTodayFormatted();
    this.loadingAll.next(true);
    if(version != this.OFFICE)
    {
      this.daySub = this.getTodaysJobsAll().subscribe(
        (res) => {
          this.allJobsSubject.next({date: todayStr, jobs: res.Jobs.filter(job => job.sitevisitrqd === true || job.istrip === true)});
          this.loadingAll.next(false);
        }, err => {
          this.allJobsSubject.next({date: todayStr, jobs: []});
          this.loadingAll.next(false);
        }
      )
    }else {
      this.daySub = this.getTodaysSiteVisitJobsAll().subscribe(
        (res) => {
          this.allJobsSubject.next({date: todayStr, jobs: res.Jobs});
          this.loadingAll.next(false);
        }, err => {
          this.allJobsSubject.next({date: todayStr, jobs: []});
          this.loadingAll.next(false);
        }
      )
    }

    const jobsHttp$ = this.getTodaysJobs(version);

    this.pageSub = jobsHttp$.pipe(
      map(res => res),
      tap((res) => {
        this.isLoading = false;
      })
    ).subscribe(
      res => {

        this.loadingDate.next(false);
        this.initialSubject.next(res.Jobs);
        this.pages.next(res.Pages);

        if(!this.authenticatedAndFiltered)
        {
          this.subject.next({date: todayStr, jobs: res.Jobs, pages: res.Pages});
          this.loadAllActivated.next(true);
        }
      }, err => {
        this.loadingDate.next(false);
        this.subject.next({date: todayStr, jobs: []});
        this.messager.openSnackBar('Error loading jobs', '', 'errorAlert');
      }
    );
  }

  /**
   * Populates ONLY the day-state subjects the clock buttons read
   * (dayStarted / isPaused / firstJob / isClockedIn).
   *
   * init() does this as well, but it also pulls the whole schedule grid for today and
   * dereferences profile['https://rhv2.com.metadata'].id off a subject seeded with [],
   * which throws on a cold deep link (setProfile() runs from app.component, not here).
   * The job page (/viewJobs/:address/:id) is a single-location page opened directly
   * from a link, so it needs the day state and none of the grid.
   */
  initDayStatuses(): void {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    this.auth.userProfile$.subscribe((profile) => {
      if (!profile) { return; }

      this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/getDayStatuses/' + this.auth.getEmployeeId(), {timezone: timezone}, {observe: 'body'}).subscribe(
        res => {
          this.dayStarted.next(res.data.daystarted);
          this.isPaused.next(res.data.daypaused);
          this.firstJob.next(res.data.donefirstjob);
        }
      );

      this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/stillClockedIn/' + this.auth.getEmployeeId(), {timezone: timezone}, {observe: 'body'}).subscribe(
        res => { this.isClockedIn.next(res.data); }
      );
    });
  }


  getTodayFormatted(): string {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const yyyy = now.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  }


  getCurrentJobs(): Observable<any> {
    return this.gridObject$;
  }

  getCurrentJobsOffice(): Observable<any> {
    return this.officeGridObject$;
  }

  getAllJobs(): Observable<any> {
    return this.allJob$;
  }

  loadAllInitial(): void {
    this.loadingDate.next(true);
    this.loadAllActivated.next(true);
    this.loadingDate.next(false);
    this.messager.openSnackBar('All jobs loaded.', '', 'successAlert');
  }

  setLoadingDate(isLoading: boolean): void {
    this.loadingDate.next(isLoading);
  }

  getJobsByRater(id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/getJobsForRater/' + id, {observe: 'body'});
  }

  // Proxies the Lennar Final/PDWI n8n webhook through our backend to avoid browser CORS.
  postLennarWebhook(payload): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/lennarWebhook', payload, {observe: 'body'});
  }

  startDayAfterEnded(timezone): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/startDayAfterEnded/' + this.auth.getEmployeeId(), {timezone: timezone}, {observe: 'body'});
  }

  getDayStarted(): Observable<boolean> {
    return this.dayStarted.asObservable();
  }

  getFirstJob(): Observable<boolean> {
    return this.firstJob.asObservable();
  }

  getIsPaused(): Observable<boolean> {
    return this.isPaused.asObservable();
  }

  getIsClockedIn(): Observable<boolean> {
    return this.isClockedIn.asObservable();
  }

  checkClockedIn(timezone){
    this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/stillClockedIn/' + this.auth.getEmployeeId(), {timezone: timezone}, {observe: 'body'}).subscribe(
      res => {
          this.isClockedIn.next(res.data);
        },
      err => {
        this.messager.openSnackBar('There was an error getting clocked in status: ' + err, '', 'errorAlert');
        this.isClockedIn.next(false);
      }
    );
  }

  getTodaysTimecard(emp_id, timezone): Observable<any>{
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/getTodaysTimecard/' + emp_id, {timezone: timezone}, {observe: 'body'});
  }

  getOneJob(job_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getOneJob/' + job_id, {observe: 'body'});
  }

  getJobData(job_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/jobdetails/' + job_id, {observe: 'body'});
  }

  convertToLocalTime(isoString: string): string {
    const date = new Date(isoString);
    return date.toLocaleString();
  }


  saveExportToDB(jobsToday: any[]):Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/locations/postjobexport', {data:jobsToday}, {observe: 'body'});
  }

  renderJobsInNewTab(id):Observable<any> {
    return this.http.get(this.baseURL + '/m/jobexports/' + id, {observe: 'body'});
  }


  isUserClockedIn(emp_id, timezone):Observable<any>{
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/stillClockedIn/' + emp_id, {timezone: timezone}, {observe: 'body'});
  }

  getDayInfo(emp_id, timezone) : Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/getDayInfo/' + emp_id, {timezone: timezone}, {observe: 'body'});
  }

  getPages() {
    return this.pages;
  }

  createDayEntry(emp_id, timezone): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/createEntry/' + emp_id, {timezone: timezone}, {observe: 'body'});
  }

  endDayEntry(emp_id, timezone): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/endDayEntry/' + emp_id, {timezone: timezone}, {observe: 'body'});
  }

  getScheduledJobsForEmployee(emp_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/scheduledJobs/' + emp_id, {observe: 'body'});
  }


  updateLastClockout(dayid: any, timezone): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/updateLastClockOut/' + dayid, {timezone: timezone},{observe:'body'});
  }

  updateLastClockOutAndPauseTime(dayid: any, timezone): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/updateLastClockOutandPT/' + dayid, {timezone: timezone}, {observe: 'body'});
  }

  updatePaused(dayid: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/updatePaused/' + dayid,  {observe: 'body'});
  }

  setProfile(profile: any) {
    this.userProfile.next(profile);
  }

  updateJobNotes(jobid, data): Observable<any> {
    let obj = {
      job_notes : data
    };
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/updateJobNotes/' + jobid, obj, {observe: 'body'});
  }

  dateChange(date: string, all, version: number = this.NORMAL) {

    // A new pick cancels whatever the previous pick still had in flight.
    if (this.pageSub) { this.pageSub.unsubscribe(); }
    if (this.daySub) { this.daySub.unsubscribe(); }

    this.isLoading = true;
    this.loadingDate.next(true);
    let jobb$;

    if(version == this.NORMAL){
       jobb$ = this.auth.role == 'User' ? this.getJobsByDateID(date, this.auth.getEmployeeId()) : this.getJobsByDate(date,0);
    }else {
       jobb$ = this.auth.role == 'User' ? this.getJobsByDateSiteVisitID(date, this.auth.getEmployeeId()) : this.getJobsByDateSVAll(date);
    }

    this.pageSub = jobb$.pipe(
      map(res => res),
      tap(res => {
        this.isLoading = false;
      })
    ).subscribe(
      res => {
        let nextJobs = version === this.NORMAL ? res.Jobs.filter(job => job.sitevisitrqd === true || job.istrip === true) : res.Jobs.filter(job => job.sitevisitrqd === false);
        this.subject.next({date: date, jobs: nextJobs, pages: res.Pages});
        this.loadingDate.next(false);
        this.pages.next(res.Pages);
      }, err => {
        this.subject.next({date: date, jobs: []});
        this.loadingDate.next(false);
        this.messager.openSnackBar('Error loading jobs', '', 'errorAlert');
      }
    );

    if(all){
      this.loadingDate.next(true);
    }

    this.loadingAll.next(true);
    const day$ = version == this.NORMAL ? this.getJobsByDateAll(date) : this.getJobsByDateSVAll(date);
    this.daySub = day$.subscribe(
      (res) => {
        const jobs = version == this.NORMAL ? res.Jobs.filter(job => job.sitevisitrqd === true || job.istrip === true) : res.Jobs;
        this.allJobsSubject.next({date: date, jobs: jobs});
        this.loadingDate.next(false);
        this.loadingAll.next(false);
      }, err => {
        this.allJobsSubject.next({date: date, jobs: []});
        this.loadingAll.next(false);
        this.messager.openSnackBar('Error loading the full day list', '', 'errorAlert');
      });
  }

  getJobsByDate(date: string, page): Observable<any> {

    const user_id = this.auth.role !== "TManager" ? this.auth.getEmployeeId(): null;
      return this.http.get(
        this.baseURL +
          `/rhAPI/jobsByDatePages/${date}/${page}/${
            user_id ? `${user_id}` : null
          }`,
        { observe: "body" }
      );

  }

  getFilterJob(date: string, type: string): Observable<any> {
      return this.http.get(
        this.baseURL +
          `/rhAPI/jobsFilterByType/${date}/${type}`,
        { observe: "body" }
      );

  }

  getJobsByDateAndSiteVisit(date: string, page): Observable<any> {

    const user_id = this.auth.role !== "TManager" ? this.auth.getEmployeeId(): null;
      return this.http.get(
        this.baseURL +
          `/rhAPI/jobsByDateSiteVisitPages/${date}/${page}/${
            user_id ? `${user_id}` : null
          }`,
        { observe: "body" }
      );

  }



  getJobsByDateID(date: string, id): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/jobsByDateFullListId/' + id + '/' + date, {observe: 'body'});
  }

  getReviewers(job_id: number): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/customers/getReviewers/' + job_id, {observe: 'body'});
  }

  getJobsByDateSiteVisitID(date: string, id): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/jobsByDateFullListSVId/' + id + '/' + date, {observe: 'body'});
  }

  getJobsByDateAll(date: string): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobsByDate/' + date, {observe: 'body'});
  }

  getJobsByDateSVAll(date: string): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntryDateSiteVisit/' + date, {observe: 'body'});
  }

  getFlexJobs(): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getFlexJobs', {observe: 'body'});
  }

  getTodaysJobs(version: number): Observable<any> {


    const formattedDate = this.getTodayFormatted();
    const user_id = this.auth.role !== "TManager" ? this.auth.getEmployeeId(): null;

    if(version == this.NORMAL) {
    return this.http.get(
      this.baseURL +
        `/rhAPI/jobsByDatePages/${formattedDate}/${0}/${
          user_id ? `${user_id}` : null
        }`,
      { observe: "body" }
    );
    }else{
      let jobb$;
      jobb$ = this.auth.role == 'User' ? this.getJobsByDateSiteVisitID(formattedDate, this.auth.getEmployeeId()) : this.getJobsByDateSVAll(formattedDate);
      return jobb$
    }

  }


  getTodaysJobsAll(): Observable<any> {

    const dated = new Date(Date.now());
    const dd = dated.getDate();
    const mm = dated.getMonth() + 1;

    const yyyy = dated.getFullYear();
    const day = dd < 10 ? '0' + dd : dd;
    const month = mm < 10 ? '0' + mm : mm;

    const formattedDate = month + '-' + day + '-' + yyyy;
    return this.http.get(this.baseURL + '/rhAPI/jobsByDate/' + formattedDate, {observe: 'body'});
  }

  getTodaysSiteVisitJobsAll(): Observable<any> {

    const dated = new Date(Date.now());
    const dd = dated.getDate();
    const mm = dated.getMonth() + 1;

    // tslint:disable-next-line: indent
    const yyyy = dated.getFullYear();
    // tslint:disable-next-line: radix
    const day = dd < 10 ? '0' + dd : dd;
    const month = mm < 10 ? '0' + mm : mm;

    const formattedDate = month + '-' + day + '-' + yyyy;

    return this.http.get(this.baseURL + '/rhAPI/jobEntryDateSiteVisit/' + formattedDate, {observe: 'body'});

  }

  getTodaysJobsID(id?: number): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobsByDateId/' + id, {observe: 'body'});
  }

  getTodaysJobsSVID(id?: number): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobsByDateSVId/' + id, {observe: 'body'});
  }

  setInitialLoaded(initialLoaded:boolean): void {
    this.loadAllActivated.next(initialLoaded);
  }



  dispatchNewQI(job: any): Observable<any> {

    return this.http.post('https://raterhelperv2.herokuapp.com/rhAPI/newDispatch/' + job.job_id, job, {observe: 'body'});
  }

  sendTestEmail() {
    this.http.post<any>(this.baseURL + '/rhAPI/emails/test', '', {observe: 'body'}).subscribe(
      res => {
          if (res.Error) {
            this.messager.openSnackBar('There was an error sending email: ' + res.Message, '', 'errorAlert');
          } else {
            this.messager.openSnackBar('Successfully sent email', '', 'successAlert');
          }
        },
      err => {
        this.messager.openSnackBar('There was an error sending email: ' + err, '', 'errorAlert');
      }
    );

  }

  updateStartTime(job, emp_id, timezone): Observable<any>
  {
    job.user = emp_id;
    job.timezone = timezone;
    return this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/updateStartTime/' + job.job_id, job, {observe: 'body'});
  }

  updateTimeToFirstJob(technitian: any, starttime: any, timezone) :Observable<any> {
    return this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/updatettfj/' +technitian, {date: starttime, timezone: timezone},{observe: 'body'});
  }

  getParticipants(jobid): Observable<any> {
    return this.http.get<any>(this.baseURL + '/rhAPI/jobEntry/getParticipants/' + jobid);
  }

  updateTravelTime(technitian: any, starttime: any, timezone) : Observable<any> {
    return this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/updatetraveltime/' + technitian, {date: starttime, timezone: timezone}, {observe:'body'});
  }

  updateFrontPage(): Observable<any>
  {
    return this.http.get<any>(this.baseURL + '/rhAPI/jobEntry/getClockedInUsers');
  }

  updateEndTime(job, empid, timezone): Observable<any>
  {
    return this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/updateEndTime/' + job.job_id, {employeeid : empid, timezone : timezone}, {observe: 'body'});
  }

  updateJobTimes(payload: any): Observable<any> {
    console.log(payload);
    return this.http.post<any>(this.baseURL + '/rhAPI/jobEntry/updateTimeByDate/' + payload.job_id, payload, {observe: 'body'});
  }

  sendEmail(job): Observable<any> {
    return this.http.post<any>(this.baseURL + '/rhAPI/emails/final', job, {observe: 'body'});
  }

  getRaterformData(obj): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/raterformsId/' + obj.form_id, {observe:'body'});
  }

  getRaterNotes(locationid): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/raternotes/' + locationid, {observe: 'body'});
  }

  addRaterNotes(locationid): Observable<any>{
    return this.http.post(this.baseURL + '/rhAPI/raternotes/add/' + locationid, '', {observe: 'body'});
  }

  getDrainCamData(job_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getDrainCam/' + job_id, {observe:'body'});
  }

  getSafteyInspectionData(job_id):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getSafetyInspection/' + job_id, {observe:'body'});
  }

  getJobsByLocation(locationid): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/getJobsByLocation/' + locationid, {observe: 'body'});
  }

  
  getRaterPics(jobid): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/getPics/' + jobid, {observe: 'body'});
  }

  getFailReasons(): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getFailReasons', {observe: 'body'});
  }

  getReviewContact(job): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getReviewContact/' + job.job_id, {observe: 'body'});
  }

  loadElevationPhotos(l_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/getelevPics/' + l_id, {observe: 'body'});
  }

  //
  sendReviewEmail(job, type): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/emails/sendReviewEmail/' + type,job, {observe: 'body'});
  }

  sendCustomEmail(job, type): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/emails/sendCustomEmail/' + type, job, {observe: 'body'});
  }

  getLastJob(location_id, schedule_date): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getLastJobID/' + location_id + '/' + schedule_date, {observe: 'body'});
  }

  getLocationFormID(location_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/locations/getFormID/' + location_id, {observe: 'body'});
  }

  getTerritoryManager(employee_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getTerritoryManager/' + employee_id, {observe: 'body'});
  }

  getRaterPicsOne(job_id): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/getPicsOne/' + job_id, {observe: 'body'});
  }

  //adding a new picture row
  getRaterPicsAdd(job_id): Observable<any>{
    return this.http.post(this.baseURL + '/rhAPI/raterpics/addRow/' + job_id, {observe: 'body'});
  }

  //copying the pics from one record to another
  getRaterPicsAddOnly(job_id, job): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/raterpics/add/' + job_id, job, {observe: 'body'});
  }

  addNewRaterform(form): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/raterformNew/', form, {observe: 'body'} );
  }

  getRaterPicsAll(jobid): Observable<any> {
       return this.http.get(this.baseURL + '/rhAPI/raterpics/' + jobid, {observe: 'body'});
  }

  getRaterPicslocmain(locpics_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/raterpics/locmain/' + locpics_id, {observe: 'body'});
}

  getElevPicsLocmain(location_id): Observable<any> { 
    return this.http.get(this.baseURL + '/rhAPI/raterpics/getElevPicsLocmain/' + location_id, {observe: 'body'});
  }

  getRaterPicslocmainRF(locpics_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/raterpics/locmainRF/' + locpics_id, {observe: 'body'});
  }

  getRaterPicsesmfnc(location_id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/raterpics/getESMFNCpics/' + location_id, {observe: 'body'});
  }

  

  getFormByJob(job_id): Observable<any>{
    return this.http.get(this.baseURL + '/rhAPI/raterformJob/' + job_id, {observe: 'body'});
  }

  getDataByFormID(formid): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/raterformsId/' + formid, {observe: 'body'});
  }

  setForm(jobid, formObj): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/setForm/' + jobid, formObj, {observe:'body'});
  }

  setFormLocmain(location_id, form_id): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/locations/setFormID/' + location_id + '/' + form_id, {}, {observe:'body'});
  }

  setPicsLocmain(location_id, pics_id): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/locations/setLocPicsID/' + location_id + '/' + pics_id, {}, {observe:'body'});
  }

  insertLocPics(location_id, job_id): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/raterpics/addRowLoc/' + location_id + '/' + job_id, {}, {observe: 'body'});
  }

  insertLocRaternotes(loc_id): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/raternotes/insertLocRaternotes/' + loc_id, {}, {observe: 'body'});
  }

  getForm(jobid): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getFormID/' + jobid, {observe: 'body'});
  }

  getFormLocation(locid): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getFormIDLoc/' + locid, {observe: 'body'});
  }

  setFormIDofJob(jobid, formid): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/setFormID/' + jobid, {formid: formid}, {observe:'body'});
  }


  setStatus(jobid, formobj): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/setStatus/' + jobid, formobj, {observe:'body'});
  }

  setFailReason(jobid, formObj): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/setFailReason/' + jobid, formObj, {observe:'body'});
  }

  getFailJobReasons(jobid): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getJobFailReasons/' + jobid, {observe: 'body'});
  }

  setPDWcomplete(locid): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/setpdwcomplete/' + locid,{},{observe:'body'});
  }

  getResponsibleTrades(id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getResponsibleTrades/' + id, {observe: 'body'});
  }


  getPhotosForJob(job): Observable<any> {
    const jID = job.job_id;
    return this.http.get(this.baseURL + '/rhAPI/raterpics/' + jID, {observe: 'body'});
  }

  updateConfStatus(jobid, status): Observable<any> {
    let obj = {
      status : status
    };
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/updateConfStatus/' + jobid, obj,{observe:'body'});
  }

  getHolidays(year?: number): Observable<any> {
    return this.http.get(`${this.baseURL}/rhAPI/us_holidays/${year}`, {observe: 'body'});
  }

  getExifData(imagename: any): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/raterpics/getExifData/' + imagename, {observe: 'body'});
  }

  getESChecklistPics(location_id: any):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/locations/getESChecklistPics/' + location_id, {observe: 'body'});
  }

  getJobConditionPics(location_id: any):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/locations/getJobConditionPics/' + location_id, {observe: 'body'});
  }

  getSelfiePic(location_id: any):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/locations/getSelfiePic/' + location_id, {observe: 'body'});
  }

  getSelfieByJob(job_id: any):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/raterpics/selfieByJob/' + job_id, {observe: 'body'});
  }
  
  getTrueHomesCharlotteNorth(): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/subdivisions/getTrueHomesCharlotteNorth', {observe: 'body'});
  }

  getAllRegions(): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/city/getRegions', {observe: 'body'});
  }

  getTrueHomesRegions(subdivision: number): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/subdivisions/getTrueHomesRegions/' + subdivision, {observe: 'body'});
  }
  
  getDayInfoByDate(id: any, formattedDate: string, timezone: string): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/getDayInfoByDate/' + id, {date: formattedDate, timezone: timezone}, {observe: 'body'});
  }
  getTimecardByDate(id: any, formattedDate: string, timezone: string): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/getTimeCardbyDate/' + id, {date: formattedDate, timezone: timezone}, {observe: 'body'});
  }
  
  searchPicsID(location_id: any): Observable <any> {
    return this.http.get(this.baseURL + '/rhAPI/locations/searchPicsID/' + location_id, {observe: 'body'});
  }

  getEmployeesByRegion(loggedInUser: any) : Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getEmployeesByRegion/' + loggedInUser, {observe: 'body'});
  }

  getEmployees(emp: any) : Observable<any>{
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/getEmployees', {employees: emp}, {observe: 'body'});
  }

  setThermalRequired(location_id: any, needed): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/locations/setThermal/' + location_id, {thermlreqd: needed}, {observe: 'body'});
  }

  setBatchDate(data:any, schedule_date: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/setBatchDate', {items: data, schedule_date : schedule_date}, {observe: 'body'});
  }

  setBatchEmployee(data:any, employee_id: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/setBatchEmployee', {items: data, employee_id : employee_id}, {observe: 'body'});
  }

  getWarningsForBatchCredentials(data:any, employee_id: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/checkCredentialsOfAll', {items: data, employee_id : employee_id}, {observe: 'body'});
  }

  getBatchLocations(data: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/getBatchJobs', {items: data}, {observe: 'body'});
  }

  getBatchJobDates(data: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/getBatchJobDates', {items: data}, {observe: 'body'});
  }

  getMFpictures(job_id: any): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/multifamily/getMfPictures/' + job_id, {observe: 'body'});
  }

  getMFtemplate(job_id: any): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/multifamily/getTemplate/' + job_id, {observe: 'body'});
  }

  getEstimatedTime(emp_id: any): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getEstimatedTime/' + emp_id, {observe: 'body'});
  }

  getTripJobs(job_id: any): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getTripJobs/' + job_id, {observe: 'body'});
  }

  getPastTripTasks(trip_id: any): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getPastTripTasks/' + trip_id, {observe: 'body'});
  }

  // Timecard Notes
  createTimecardNote(payload: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/timecardNotes/create', payload, {observe: 'body'});
  }


  getTimecardNotesByDay(did: number): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/timecardNotes/getByDay/' + did, {observe: 'body'});
  }

  deleteTimecardNote(id: number): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/timecardNotes/delete/' + id, {}, {observe: 'body'});
  }

  getTimecardNotesByEmployee(employeeId: number, startDate: string, endDate: string): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/timecardNotes/getByEmployee/' + employeeId
      + '?startDate=' + startDate + '&endDate=' + endDate, {observe: 'body'});
  }

  getFutureTrips(locationId: any, afterDate: string): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getFutureTrips/' + locationId + '?after_date=' + afterDate, { observe: 'body' });
  }






}
